export enum ApplicationDecision {
    ReadyToSign = "ReadyToSign",
    Accepted = "Accepted",
    Declined = "Declined",
    CounterOffered = "CounterOffered",
    Timeout = "Timeout",
}